'use strict';

import {Vector2} from 'three';
import {getCanvasWidthDiff, renderUpdateValuesOnDemand, updateRaycaster, updateRenderer} from '../../app';
import { closeAllDropDownLang, getCurrentLangDirection } from '../language/langSwitcher';
import { closeAsideMenu } from '../menu/menu';
import { isMobile, projectMode, settingsData, threeJsVariables } from '../../settings';
import {checkIntersection} from "../threejs/raycast";
import { closePoiInfoWindowCardInOrbit } from '../poi/poiCss';
import {stopCameraTour} from "../camera-auto-tour/cameraTour";
import {updateMousePosition} from "../post-processing/depthOfFields2";
import { autoRotateTimerAction } from './orbitControls';

let doubleClickTimer = '';
let mouseMoveEvent, isPressed;
let timeOne = null;
let prevSelectedObject = null;

export const RaycastHandler = (settings) => {
    const canvas = document.getElementById('c');

    ['pointerup', 'pointerdown', 'pointermove'].forEach(itemEvent => {
        canvas.addEventListener(itemEvent, (event) => {
            mouseHandler(event, settings, canvas);
            renderUpdateValuesOnDemand(false);
            // settingsData.tourIsActive = false;
            if (itemEvent === 'pointerdown') {
                stopCameraTour();
            }
            settingsData.last_interaction = Date.now();
        }, true);
    });
}

let pointersArray = [];

function mouseHandler(event, settings, canvas) {
    // if (!threeJsVariables.orbitControls.enabled) {
    //     !settingsData.isClickEvent && doubleEventCheck();
    //     return;
    // }

    if (projectMode.LiteMode.preventPointerEvents(undefined)){
        settingsData.isClickEvent = event.pointerType === 'mouse';
        settingsData.isTouchEvent = event.pointerType === 'touch';
        return;
    }

    const canvasSize = threeJsVariables.renderer.getSize(new Vector2());
    const canvasDiff = getCanvasWidthDiff();
    // const langDir = getCurrentLangDirection();
    // if (langDir === 'rtl') {
    //     canvasDiff.x = 0;
    // }

    if (!canvas) {
        return;
    }

    switch (event.type) {

        case 'pointerdown': {
            // doubleEventCheck();
            autoRotateTimerAction('update');
            if (settingsData.bombBlock) return;

            settingsData.isClickEvent = event.pointerType === 'mouse';
            settingsData.isTouchEvent = event.pointerType === 'touch';

            mouseMoveEvent = Date.now();
            isPressed = true;

            if (pointersArray.indexOf(event.pointerId) === -1) {
                pointersArray.push(event.pointerId);
            }

            threeJsVariables.mouse.x = ((event.clientX - canvasDiff.x) / canvasSize.x) * 2 - 1;
            threeJsVariables.mouse.y = -(event.clientY / canvasSize.y) * 2 + 1;
            threeJsVariables.mouse.winX = event.clientX;
            threeJsVariables.mouse.winY = event.clientY;
            closeAllDropDownLang(event);
            closeAsideMenu();

            if (isMobile){
                closePoiInfoWindowCardInOrbit(true);
            } else {
                closePoiInfoWindowCardInOrbit(false);
            }

            updateRaycaster();
            break;
        }
        case 'pointermove':
            if (isPressed && Date.now() - mouseMoveEvent >= 100) {
                settingsData.intersectionBlock = true;
                // if (isMobile){
                //     closePoiInfoWindowCardInOrbit(true);
                // } else {
                //     closePoiInfoWindowCardInOrbit(false);
                // }
            }

            threeJsVariables.mouse.x = ((event.clientX - canvasDiff.x) / canvasSize.x) * 2 - 1;
            threeJsVariables.mouse.y = -(event.clientY / canvasSize.y) * 2 + 1;
            threeJsVariables.mouse.winX = event.clientX;
            threeJsVariables.mouse.winY = event.clientY;

            updateRaycaster();
            updateRenderer();
            updateMousePosition(event);

            settingsData.isIntersection = true;
            break;
        case 'pointerup': {
            if (pointersArray.length > 1 && !pointersArray.length) {
                pointersArray = [];
                resetPointerCoords();
                return;
            }
            pointersArray = [];

            isPressed = false;
            if (Date.now() - mouseMoveEvent >= 300) {
                resetPointerCoords();
            } else {
                clickHandler(settings);
            }

            settingsData.intersectionBlock = false;

            break;
        }
    }
}

function clickHandler() {

    resetPointerCoords();
    checkIntersection('click');
}

export function doubleEventCheck(selectedObject) {
    // const diff = Date.now() - doubleClickTimer;

    switch (selectedObject.userData.type) {
        case 'building':
            prevSelectedObject = settingsData.selectedObject;
            break;
        case 'selectionBoxes':
            prevSelectedObject = settingsData.lastClickedFlat;
            break;
    }


    if (doubleClickTimer && Date.now() - doubleClickTimer < 300 && prevSelectedObject !== null && selectedObject === prevSelectedObject ) {
        settingsData.doubleClick = true;
        setTimeout(() => {settingsData.doubleClick = false}, 100)
    } else {
        settingsData.doubleClick = false;
        doubleClickTimer = Date.now();
    }

    return settingsData.doubleClick;
}

function resetPointerCoords() {
    threeJsVariables.mouse.x = -10000;
    threeJsVariables.mouse.y = -10000;
    settingsData.current_mouse_position.x = -10000;
    settingsData.current_mouse_position.y = -10000;
}
